export default __webpack_public_path__ + "static/promo2-224a75af5f264d41156c93f3bfe98d7e.png";